import React from "react";
import { Monitor, Cpu, Headphones, AppWindow, Mouse, Info, ChevronRight, CircleCheck, Phone, Mail, MapPin, ShieldCheck, Truck } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
const products = [{
  id: 1,
  title: "Tiefbau & Erschließung",
  description: "Professionelle Lösungen für Fundamente, Kanalbau und komplexe Rohrleitungssysteme.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/tiefbau.png",
  status: "Verfügbar",
  hoverInsight: "Wir setzen modernste GPS-gesteuerte Baggertechnik ein, um Erschließungsarbeiten mit einer Präzision von wenigen Millimetern nach Ihren Bauplänen auszuführen.",
  icon: Cpu
}, {
  id: 2,
  title: "Erdarbeiten & Aushub",
  description: "Effizienter Bodenaushub und fachgerechtes Bodenmanagement für jedes Bauvorhaben.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/erdarbeiten.png",
  status: "Einsatzbereit",
  hoverInsight: "Vom Kellerbau bis zur Großbaustelle: Unser Maschinenpark bewältigt Massenbewegungen effizient inklusive fachgerechter Entsorgung und Bodenverbesserung.",
  icon: Mouse
}, {
  id: 3,
  title: "Außenanlagen & Gartenbau",
  description: "Ganzheitliche Gestaltung Ihrer Außenbereiche – funktional, ästhetisch und langlebig.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/aussenanlagen.png",
  status: "Planungsphase",
  hoverInsight: "Wir integrieren Hangsicherungen, Treppenanlagen und Entwässerungskonzepte nahtlos in das Landschaftsbild Ihres Grundstücks für maximale Beständigkeit.",
  icon: AppWindow
}, {
  id: 4,
  title: "Pflasterbau & Wegebau",
  description: "Hochwertige Pflasterarbeiten für Einfahrten, Terrassen und öffentliche Wegeflächen.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/pflasterbau.png",
  status: "Verfügbar",
  hoverInsight: "Ob Naturstein oder Betonverbundpflaster: Wir garantieren einen tragfähigen Unterbau und präzise Verlegemuster für extrem belastbare Verkehrsflächen.",
  icon: Headphones
}, {
  id: 5,
  title: "Maschinenvermietung",
  description: "Moderner Fuhrpark vom Minibagger bis zum Radlader für Ihr Eigenprojekt.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1594803/img/maschinen.png",
  status: "Saison-Highlight",
  hoverInsight: "Alle Mietmaschinen werden nach jedem Einsatz gewartet. Wir bieten optionale Einweisungen oder gestellte Fachfahrer für maximale Sicherheit auf Ihrer Baustelle.",
  icon: Monitor
}];
const productSpecs = [{
  productId: 1,
  spec: "Kanal- & Leitungsbau"
}, {
  productId: 1,
  spec: "Fundamenterstellung"
}, {
  productId: 1,
  spec: "Druckprüfungen"
}, {
  productId: 2,
  spec: "Baugrubenaushub"
}, {
  productId: 2,
  spec: "Geländemodellierung"
}, {
  productId: 2,
  spec: "Bodenverdichtung"
}, {
  productId: 3,
  spec: "Hangsicherungen"
}, {
  productId: 3,
  spec: "Zaun- & Mauerbau"
}, {
  productId: 3,
  spec: "Entwässerung"
}, {
  productId: 4,
  spec: "Natursteinpflaster"
}, {
  productId: 4,
  spec: "Terrassenbau"
}, {
  productId: 4,
  spec: "Großflächenbau"
}, {
  productId: 4,
  spec: "Pflasterarbeiten aller art"
}, {
  productId: 4,
  spec: "Außenanlagen"
}, {
  productId: 5,
  spec: "Bagger 1t - 20t"
}, {
  productId: 5,
  spec: "Radlader"
}, {
  productId: 5,
  spec: "Kippersattelzug"
}, {
  productId: 5,
  spec: "Auflieger"
}, {
  productId: 6,
  spec: "Kipper LKW 7,5 t"
}, {
  productId: 5,
  spec: "Kipper LKW 7,5t"
}];
const services = [{
  id: 1,
  text: "Traditioneller mit Handschlagqualität"
}, {
  id: 2,
  text: "Langjährige Erfahrung im Tief- und Erdbau"
}, {
  id: 3,
  text: "Saubere, termingerechte und zuverlässige Ausführung"
}, {
  id: 4,
  text: "Faire Preise durch effiziente regionale Planung"
}, {
  id: 5,
  text: "Außenanlagen"
}];
export default function TechnologyProducts() {
  return <section data-section-id="146911" id="industrialprecision" className="text-foreground py-20 overflow-hidden !bg-[hsl(43,96%,56%)] lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {}
        <div className="mb-16 md:mb-24 max-w-3xl">
          
          <h2 className="text-4xl md:text-5xl font-sans font-bold tracking-tighter mb-6 text-foreground">
            Ihr Partner für <span className="text-transparent bg-clip-text bg-gradient-to-r from-chart-1 to-chart-1/80">Tiefbau & Außenanlagen</span>
          </h2>
          <p className="text-xl text-muted-foreground leading-relaxed font-sans">Zuverlässig. Regional. Wir realisieren Ihre Projekte im Tiefbau, Erdbau und Außenanlagenbau mit modernster Technik und handwerklicher Präzision.</p>
        </div>

        {}
        <div className="grid grid-cols-1 gap-6 mb-24">
          {products.map((product, index) => {
          const Icon = product.icon;
          const colSpan = index === 0 || index === 3 ? "lg:col-span-7" : "lg:col-span-5";
          return <div key={product.id} data-index={index} className="w-full">
                <Card className="w-full bg-secondary text-secondary-foreground border-white/5 shadow-lg relative overflow-hidden group flex flex-col rounded-sm">
                  {}
                  <div className="absolute inset-0 border border-white/5 rounded-sm pointer-events-none z-10"></div>
                  
                  <div className="relative overflow-hidden bg-black/40">
                    <AspectRatio ratio={16 / 9}>
                      <img src={product.image} alt={product.title} className="object-cover w-full h-full opacity-70 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 mix-blend-luminosity group-hover:mix-blend-normal" />
                      <div className="absolute inset-0 bg-gradient-to-t from-secondary via-secondary/40 to-transparent"></div>
                    </AspectRatio>
                    <div className="absolute top-4 right-4 z-20">
                      <Badge className="bg-chart-1 text-primary-foreground border-none rounded-sm font-mono text-xs uppercase tracking-wider shadow-md">
                        {product.status}
                      </Badge>
                    </div>
                    <div className="absolute bottom-4 left-6 z-20 flex items-center gap-3">
                      <div className="p-2 bg-secondary/80 backdrop-blur-md rounded-sm border border-white/10">
                        <Icon className="size-5 text-chart-1" />
                      </div>
                      <h3 className="font-sans font-bold text-2xl tracking-tighter text-white">
                        {product.title}
                      </h3>
                    </div>
                  </div>

                  <CardContent className="flex-grow pt-6 px-6 flex flex-col">
                    <p className="text-secondary-foreground/80 text-base mb-6 line-clamp-2 font-sans">
                      {product.description}
                    </p>
                    
                    <div className="mt-auto">
                      <Separator className="bg-white/10 mb-4" />
                      <ul className="space-y-2 mb-6">
                        {productSpecs.filter(s => s.productId === product.id).map((spec, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-sm font-mono text-secondary-foreground/70 !justify-start">
                              <span className="size-1.5 rounded-none bg-chart-1"></span>
                              {spec.spec === "Auflieger" ? <Link to="/auflieger" className="hover:text-chart-1 transition-colors">{spec.spec}</Link> : spec.spec}
                            </li>)}
                      </ul>
                    </div>

                    <div className="flex items-center justify-between mt-auto pt-4">
                      <HoverCard>
                        <HoverCardTrigger asChild>
                          <Button variant="ghost" size="sm" className="text-chart-1 hover:text-chart-1 hover:bg-white/5 font-mono text-xs uppercase tracking-wider">
                            <Info className="size-4 mr-2" />
                            Details
                          </Button>
                        </HoverCardTrigger>
                        <HoverCardContent className="w-80 bg-popover text-popover-foreground border-border shadow-xl rounded-sm">
                          <div className="space-y-2">
                            <h4 className="font-sans font-bold text-sm flex items-center gap-2 text-chart-1">
                              <Cpu className="size-4" />
                              Bautechnische Details
                            </h4>
                            <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                              {product.hoverInsight}
                            </p>
                          </div>
                        </HoverCardContent>
                      </HoverCard>

                      <Button asChild className="bg-chart-1 hover:bg-chart-1/90 text-primary-foreground rounded-sm px-6 shadow-inner transition-all font-sans font-bold uppercase tracking-tight">
                        <Link to="/ContactPage">
                          Projekt anfragen
                          <ChevronRight className="size-4 ml-1" />
                        </Link>
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pt-12 border-t border-border">
          {}
          <div>
            <h3 className="text-3xl font-sans font-bold mb-6 text-foreground tracking-tighter">Warum Wir</h3>
            <p className="text-lg text-muted-foreground mb-8 font-sans">Wir begleiten Sie von der ersten Planung bis zur finalen Abnahme. Unser Team garantiert eine saubere Baustelle und eine Ausführung, die bautechnischen Standards entspricht.</p>
            <ul className="space-y-4">
              {services.map((service, index) => <li key={service.id} data-index={index} className="flex items-start gap-3">
                  <CircleCheck className="size-5 text-chart-1 shrink-0 mt-1" />
                  <span className="text-foreground font-sans font-semibold">{service.text}</span>
                </li>)}
            </ul>
          </div>

          {}
          <div className="bg-muted/30 rounded-sm p-8 border border-border">
            <h3 className="text-3xl font-sans font-bold mb-6 text-foreground tracking-tighter">Kontakt & Beratung</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-background rounded-sm shadow-sm border border-border shrink-0">
                  <MapPin className="size-5 text-chart-1" />
                </div>
                <div>
                  <h4 className="font-bold text-foreground mb-1 font-sans">Firmensitz</h4>
                  <address className="not-italic text-muted-foreground text-sm leading-relaxed font-sans">Hoch&amp;Tiefbau T&amp;M<br />Gymnasialstraße 2<br />55543 Bad Kreuznach<br />Deutschland</address>
                </div>
              </div>
              
              <Separator className="bg-border" />
              
              
            </div>
          </div>
        </div>

      </div>
    </section>;
}